<div class="d-flex" [ngClass]="theme" *ngIf="open">
	<ng-content></ng-content>
</div>
